import request from '@/util/http'

// 获取学期
export const getSemesterSel=(params)=>request({
    url: '/hq/kb/semester',
    method: 'get',
    params
})
//获取学期周次
export const getWeekSel=(params)=>request({
    url: '/hq/kb/semesterWeek',
    method: 'get',
    params
})
//获取教师列表
export const getTeaSel=(params)=>request({
    url: '/hq/kb/teacherList',
    method: 'get',
    params
})
//获取教师课表
export const getTeaTimeTab=(params)=>request({
    url: '/hq/kb/teacherKbInfo',
    method: 'get',
    params
})
export const getTeaTimeTab_new=(params)=>request({
    url: '/hq/kb/newTeacherKbInfo',
    method: 'get',
    params
})
//获取课表节次
export const getTimeTabWeek=(params)=>request({
    url: '/hq/kb/jcConfig',
    method: 'get',
    params
})
export const getClassList=(params)=>request({
        url: '/hq/kb/classList',
        method: 'get',
        params
})
//获取班级课表
export const getClassTimeTab=(params)=>request({
    url: '/hq/kb/classKbInfo',
    method: 'get',
    params
})
export const getClassTimeTab_new=(params)=>request({
    url: '/hq/kb/newClassKbInfo',
    method: 'get',
    params
})
export const getClassRoomList=(params)=>request({
    url: '/hq/kb/classRoomList',
    method: 'get',
    params
})

export const getClassRoomKbInfo=(params)=>request({
    url: '/hq/kb/classRoomKbInfo',
    method: 'get',
    params
})
export const getClassRoomKbInfo_new=(params)=>request({
    url: '/hq/kb/newClassRoomKbInfo',
    method: 'get',
    params
})

//获取班级课表
export const getMyKbTimeTab=(params)=>request({
    url: '/hq/kb/myKbInfo',
    method: 'get',
    params
})

export const getNewMyKbTimeTab =(params)=>request({
    url: '/hq/kb/newMyKbInfo',
    method: 'get',
    params
})
//评教查询
export const selectPCAttendance =(params)=>request({
    url: '/hq/attendance/selectPCAttendance',
    method: 'get',
    params
})
//获取基本信息
export const selectKbDetails =(params)=>request({
    url: '/hq/attendance/selectKbDetails',
    method: 'post',
    data: params
})
//获取评教详情
export const selectEvaluaDetails =(params)=>request({
    url: '/hq/evalua/selectEvaluaDetails',
    method: 'post',
    data: params
})
//评教详情课堂评分分页
export const selectEvaluaScorePage =(params)=>request({
    url: '/hq/evalua/selectEvaluaScorePage',
    method: 'get',
    params
})
//获取考勤详情
export const selectAttendanceDetails =(params)=>request({
    url: '/hq/attendance/selectAttendanceDetails',
    method: 'post',
    params
})
//获取考勤详情分页
export const selectPCAttendanceStuPage =(params)=>request({
    url: '/hq/attendance/selectPCAttendanceStuPage',
    method: 'get',
    params
})
//设置学生考勤状态
export const setClassOverviewPC =(params)=>request({
    url: '/hq/attendance/setClassOverviewPC',
    method: 'post',
    data: params
})
//考勤补签分页
export const getSupList =(params)=>request({
    url: '/hq/attendance/getMakeUpPage',
    method: 'get',
    params
})
//考勤补签审批
export const setSupStatus =(params)=>request({
    url: '/hq/attendance/getMakeUpPage',
    method: 'post',
    data: params
})
//设置经纬度
export const setLangt =(params)=>request({
    url: '/hq/classroom/setClassRoomPosition',
    method: 'post',
    params: params
})
//获取签到详情
export const getRecordInfo =(params)=>request({
    url: '/hq/attendance/getSelfAttendanceDetails',
    method: 'post',
    params: params
})
//我的签到记录分页
export const getMyRecord =(params)=>request({
    url: '/hq/attendance/selfAtendance',
    method: 'get',
    params
})
//补签确认
export function setToSinIn(query) {
    return request({
        url: '/hq/attendance/signIn',
        method: 'post',
        data: query
    })
}

//我的签到记录分页
export const getAllAttendance =(params)=>request({
    url: '/hq/attendance/all-attendance',
    method: 'get',
    params
})

//签到记录分页(教师)
export const getTeacherAttendance =(params)=>request({
    url: '/hq/attendance/teacher-attendance',
    method: 'get',
    params
})

//签到记录分页(班主任)
export const getClassTeacherAttendance =(params)=>request({
    url: '/hq/attendance/class-teacher-attendance',
    method: 'get',
    params
})

//获取学生评教详情
export const selectEvaluaInfo =(params)=>request( {
    url: '/hq/evalua/selectEvaluaInfoById',
    method: 'get',
    params
})

//获取年级列表
export const getGradeNameList =(params)=>request( {
    url: '/hq/administrationClass/getGradeNameList',
    method: 'get',
    params
})
